import React, { useRef, useState } from 'react'
import Text from '../../Text'
import styles from './styles.module.css'
import CollapsibleItem from './CollapsibleItem'
import { Collapse } from '@mui/material'
import { $neutralGray80, $white } from '../../../styles/colors/primitives'
import CtaV2 from '../../CtaV2'

const cx = (...c) => c.filter(Boolean).join(' ')

function CollapsibleList({ title = '', collapsibleItems = [], ctaTitle = { show: 'View more', hide: 'Show less' }, collapsedListLength = 5, small = false, leftAligned = false, placeholderIfEmpty = null, searchTerm, sx = {
  noPadding: false,
  bgColor: $white,
  hideTitle: false,
  textColor: $neutralGray80,
} }) {
  const [showAllItems, setShowAllItems] = useState(false)
  const titleRef = useRef(null)

  const collapsedList = collapsibleItems.slice(0, collapsedListLength)
  const expandedList = collapsibleItems.slice(collapsedListLength)

  const renderList = (list, isVisibleInitially) => {
    if (list && list.length) {
      return list.map((item, i) =>
        <CollapsibleItem
          key={item._key}
          item={item}
          expandedInitially={isVisibleInitially && searchTerm && i === 0}
          textColor={sx.textColor}
          searchTerm={searchTerm}
        />
      )
    }
  }

  const handleExpandButtonClick = () => {
    if (showAllItems) {
      window.scrollTo({
        top: titleRef.current.offsetTop - 80, // TODO: 80 is height of header, refactor by storing header props to state and retrieving them here
        behavior: 'instant',
      })
    }

    setShowAllItems(!showAllItems)
  }

  return (
    <div ref={titleRef} className={styles.wrapper} style={{ backgroundColor: sx.bgColor || $white }}>
      <div className={cx(
        styles.contentWrapper,
        small && styles.contentWrapperSmall,
        leftAligned && styles.contentWrapperLeftAligned,
        !sx.noPadding && (small ? styles.contentWrapperPaddingSmall : styles.contentWrapperPadding)
      )}>
        {!sx.hideTitle && <Text type="h2" color={sx.textColor}>{title}</Text>}
        <div className={styles.listWrapper}>
          { renderList(collapsedList, true) }
          <Collapse in={showAllItems} timeout={{ enter: 500, exit: 250 }}>
            { renderList(expandedList, false) }
          </Collapse>
        </div>
        <div className={cx(styles.ctaWrapper, expandedList.length && styles.ctaWrapperShow, small && styles.ctaWrapperSmall)}>
          <CtaV2
            title={showAllItems ? ctaTitle.hide : ctaTitle.show}
            dark
            onClick={handleExpandButtonClick}
          />
        </div>
        <div className={cx(styles.emptyPlaceholder, (!expandedList.length && placeholderIfEmpty) && styles.emptyPlaceholderShow)}>
          <Text type="body-short-1">{placeholderIfEmpty}</Text>
        </div>
      </div>
    </div>
  )
}

export default CollapsibleList
